import React, { useEffect } from "react";

const DTOFeedbackEditActionModal = () => {
  return <></>;
};

export default DTOFeedbackEditActionModal;
